import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import '../css/Cliente.css';

const Cliente = () => {
  const location = useLocation();
  const { pedidosData } = location.state || {};
  const [pedidosConDocumentacionPendiente, setPedidosConDocumentacionPendiente] = useState([]);
  const [loading, setLoading] = useState(false);
  const [archivoPorPedido, setArchivoPorPedido] = useState({});
  const [documentoSeleccionadoPorPedido, setDocumentoSeleccionadoPorPedido] = useState({});
  const [IdsDocumentacionPendiente, setIdsDocumentacionPendiente] = useState([]);

  useEffect(() => {
    const fetchDocumentacion = async () => {
      if (Array.isArray(pedidosData) && pedidosData.length > 0) {
        setLoading(true);
        try {
          const promises = pedidosData.map((pedido, index) => {
            return descargarIDsDocumentacionAsignada(pedido);
          });
          await Promise.all(promises);
        } catch (error) {
          console.error('Error fetching documentacion:', error);
        } finally {
          setLoading(false);
        }
      } else {
        console.warn('pedidosData no es un array o está vacío');
      }
    };
    fetchDocumentacion();
  }, [pedidosData]);

  const descargarIDsDocumentacionAsignada = async (pedido) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/curso/buscar/${pedido.numero_producto}`
      );

      if (response.data.docu_id) {
        const IDs = response.data.docu_id.replace(/[\[\]\s]/g, '').split(',').map(id => Number(id.trim()));
        await descargarIDsDocumentacionPendiente(IDs, pedido);
      } else {
        console.warn("Este pedido aún no tiene documentación asignada, póngase en contacto con el centro.");
      }
    } catch (error) {
      console.error('Error al obtener la documentación asignada:', error);
    }
  };

  const descargarIDsDocumentacionPendiente = async (IDsAsignada, pedido) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/pedido/filtrar/${pedido.numero_pedido}`
      );

      if (response.data && response.data.pedidos && response.data.pedidos[0]) {
        const documentacionRecibida = response.data.pedidos[0].recibida.split(',').map(id => Number(id.trim()));
        const documentacionPendiente = IDsAsignada.filter(id => !documentacionRecibida.includes(id));

        // Crear un objeto con la información del pedido y la documentación pendiente
        const resultadoPedido = {
          pedido: pedido.numero_pedido,
          recibida: documentacionRecibida
        };

        setIdsDocumentacionPendiente(prev => [
          ...prev,
          resultadoPedido
        ]);

        // setDocumentacionRecibida(documentacionRecibida);
        await obtenerNombresDocumentacion(documentacionPendiente, pedido);
      }
    } catch (error) {
      console.error('No hay documentación pendiente o no se ha podido descargar:', error);
      await obtenerNombresDocumentacion(IDsAsignada, pedido);
    }
  };


  const obtenerNombresDocumentacion = async (IDsdocumentacionPendiente, pedido) => {
    if (!IDsdocumentacionPendiente || IDsdocumentacionPendiente.length <= 0) {
      console.log("No hay documentación pendiente.");
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/docu/buscar/${IDsdocumentacionPendiente}`
      );

      let DocumentacionConNombre = response.data;
      añadirDocumentacionPedido(DocumentacionConNombre, pedido);
    } catch (error) {
      console.error('Error al obtener la documentación:', error);
    }
  };

  const añadirDocumentacionPedido = (DocumentacionConNombre, pedido) => {

    setPedidosConDocumentacionPendiente(prev => {
      const existingPedido = prev.find(p => p.id === pedido.id);
      if (existingPedido) {
        return prev.map(p =>
          p.id === pedido.id
            ? { ...p, documentacionPendiente: DocumentacionConNombre }
            : p
        );
      } else {
        return [...prev, { ...pedido, documentacionPendiente: DocumentacionConNombre }];
      }
    });
  };

  const controlDeLosCheckBox = (id, nombre, pedidoNumero) => {
    setDocumentoSeleccionadoPorPedido(prev => ({
      ...prev,
      [pedidoNumero]: { id, nombre }
    }));
  };

  const manejarArchivo = (pedidoNumero, event) => {
    setArchivoPorPedido(prev => ({
      ...prev,
      [pedidoNumero]: event.target.files[0]
    }));
  };

  const subirDocumentacion = async (pedido) => {
    const documentoSeleccionado = documentoSeleccionadoPorPedido[pedido.numero_pedido];
    const archivo = archivoPorPedido[pedido.numero_pedido];

    if (!documentoSeleccionado || !documentoSeleccionado.id || !archivo) {
      alert('Selecciona un documento y un archivo antes de subir.');
      return;
    }

    const formData = new FormData();
    formData.append('documento', archivo);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/cliente/subir/${pedido.numero_producto}/${pedido.numero_pedido}/${documentoSeleccionado.nombre}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.data.success) {
        await actualizarBasePedidos(pedido, documentoSeleccionado.id);
        setArchivoPorPedido(prev => ({ ...prev, [pedido.numero_pedido]: null }));
      } else {
        alert('Error al subir la documentación.');
      }
    } catch (error) {
      console.error('Error al subir la documentación:', error);
      alert('Error al subir la documentación.');
    }
  };


  async function actualizarBasePedidos(pedido, documentoId) {
    try {
      const numero_pedido = pedido.numero_pedido;
      const numero_curso = pedido.numero_producto;

      const recibida = documentoId;
      const pedidoBuscado = pedido.numero_pedido;

      // Buscar la documentación ya entregada y añadir la que entregamos ahora
      const pedidoEncontrado = IdsDocumentacionPendiente.find(doc => doc.pedido === pedidoBuscado);

      let idsDocumentacionPendienteString;

      if (pedidoEncontrado) {
        const idsDocumentacionPendiente = pedidoEncontrado.recibida; // Esto es un array de IDs

        idsDocumentacionPendiente.push(recibida);
        idsDocumentacionPendienteString = idsDocumentacionPendiente.join(', ');

        console.log(`IDs de Documentación recibida para el pedido ${pedidoBuscado}: ${idsDocumentacionPendienteString}`);
      } else {
        // Si no hay documentos previos, `idsDocumentacionPendienteString` es solo el documento actual
        idsDocumentacionPendienteString = recibida;
        console.log(`No se encontró documentación recibida para el pedido ${pedidoBuscado}. Se añadirá: ${idsDocumentacionPendienteString}`);
      }

      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/pedido/editar`, {
        numero_curso: numero_curso,
        numero_pedido: numero_pedido,
        recibida: idsDocumentacionPendienteString
      });

      descargarIDsDocumentacionAsignada(pedido);
      alert('Documentación subida y datos actualizados.');
    } catch (error) {
      console.error('Error al actualizar la base de datos:', error);
      alert('Error al actualizar la base de datos.');
    }
  }


  return (
    <div className="contenedorCliente">
      <h2 className="tituloBienvenida">Bienvenido {pedidosData[0].nombre_cliente}</h2>
      <div className="instrucciones">
        <h3 className="tituloInstrucciones">¡Listo para subir tu documentación?</h3>
        <p className="descripcion">Aquí tienes una lista de tus pedidos con la documentación pendiente de entregar. ¡Vamos a hacerlo fácil!</p>
        <p className="descripcion">
          Selecciona el nombre de la documentación que deseas subir. <br />
          Luego presiona el botón <strong>Examinar</strong> para seleccionar tu archivo. <br />
          Finalmente, haz clic en <strong>Subir Documentación</strong> para completar el proceso.
        </p>

        <div className="extensionesAceptadas">
          <p><strong>Ten en cuenta:</strong> Solo se admiten las siguientes extensiones de archivo:</p>
          <ul className="listaExtensiones">
            <li>PDF</li>
            <li>DOC</li>
            <li>DOCX</li>
            <li>JPG</li>
            <li>JPEG</li>
            <li>PNG</li>
          </ul>
        </div>
      </div>
      {loading ? (
        <p className="loading">Cargando...</p>
      ) : (
        <>
          {pedidosConDocumentacionPendiente.length > 0 ? (
            <div className="listaPedidos">
              {pedidosConDocumentacionPendiente.map((pedido, index) => (
                <div key={index} className="pedido">
                  <h4 className="numeroPedido">Pedido: {pedido.numero_pedido}</h4>
                  <p className="nombreCurso"><strong>Nombre del curso:</strong> {pedido.nombre_producto}</p>
                  <p className="documentacionPendiente">Documentación Pendiente:</p>
                  <ul className="listaDocumentacion">
                    {pedido.documentacionPendiente.map((doc, docIndex) => (
                      <li key={docIndex} className="documentoItem">
                        <label className="documentoLabel">
                          {doc.documentacion}
                          <input
                            type="radio"
                            name={`documento-${pedido.numero_pedido}`}
                            checked={documentoSeleccionadoPorPedido[pedido.numero_pedido]?.id === doc.id_docu}
                            onChange={() => controlDeLosCheckBox(doc.id_docu, doc.documentacion, pedido.numero_pedido)}
                          />
                        </label>
                      </li>
                    ))}
                  </ul>
                  <div className="subirArchivoContainer">
                    <input
                      type="file"
                      className="subirArchivo"
                      onChange={(event) => manejarArchivo(pedido.numero_pedido, event)}
                      accept=".pdf, .doc, .docx, .jpg, .jpeg, .png"
                    />
                    <button className="botonSubir" onClick={() => subirDocumentacion(pedido)}>Subir Documentación</button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="sinDatos">No hay datos de cliente disponibles.</p>
          )}
        </>
      )}
            </div>
  );

};
export default Cliente;

